import { useNavigate as _useNavigate } from '@tanstack/react-router';

/**
 * apps-crate is compiled in every app context (ppms-ui, support-panel,
 * astronauth-ui), but its components navigate to ppms-ui-specific routes
 * that don't exist in the other apps' route trees.
 *
 * The cast is intentionally isolated here so individual call sites stay
 * clean and typed. Full path validation remains available in ppms-ui,
 * which is the only app that actually renders these components.
 */
export type CrossAppNavigate = (opts: {
  to: string
  params?: Record<string, string>
  search?: Record<string, unknown>
}) => void;

export function useNavigate(): CrossAppNavigate {
  return _useNavigate() as CrossAppNavigate;
}
